var map = {
	"./WD_PicOverlay1_1_640X960.png": 686,
	"./WD_PicOverlay2_1_640X960.png": 929,
	"./WD_PicOverlay3_1_640X960.png": 924,
	"./WD_PicOverlay4_1_640X960.png": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 559;